import { validateProps } from '../../utils';
import { isValidBase } from '../BaseEntity';
export let TaskSource = /*#__PURE__*/function (TaskSource) {
  TaskSource["UNKNOWN_SOURCE"] = "UNKNOWN_SOURCE";
  TaskSource["MANUAL"] = "MANUAL";
  TaskSource["CHAT"] = "CHAT";
  TaskSource["RECURRING_SCHEDULE"] = "RECURRING_SCHEDULE";
  TaskSource["ANONYMOUS_LINK"] = "ANONYMOUS_LINK";
  TaskSource["RECOMMENDATION"] = "RECOMMENDATION";
  return TaskSource;
}({});
export let TaskType = /*#__PURE__*/function (TaskType) {
  TaskType["RECURRING_SCHEDULE"] = "RECURRING_SCHEDULE";
  TaskType["TIME_BLOCK"] = "TIME_BLOCK";
  TaskType["SCHEDULE_MEETING"] = "SCHEDULE_MEETING";
  TaskType["SCHEDULE_VIRTUAL_MEETING"] = "SCHEDULE_VIRTUAL_MEETING";
  TaskType["CLEAR_SCHEDULE"] = "CLEAR_SCHEDULE";
  TaskType["RESCHEDULE_MEETING"] = "RESCHEDULE_MEETING";
  TaskType["OTHER"] = "OTHER";
  return TaskType;
}({});
export let TaskStatus = /*#__PURE__*/function (TaskStatus) {
  TaskStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
  TaskStatus["AWAITING_ANALYSIS"] = "AWAITING_ANALYSIS";
  TaskStatus["PENDING_APPROVAL"] = "PENDING_APPROVAL";
  TaskStatus["IN_PROGRESS"] = "IN_PROGRESS";
  TaskStatus["AWAITING_DETAILS"] = "AWAITING_DETAILS";
  TaskStatus["ACTION_NEEDED"] = "ACTION_NEEDED";
  TaskStatus["COMPLETE"] = "COMPLETE";
  TaskStatus["CANCELED"] = "CANCELED";
  TaskStatus["FAILED"] = "FAILED";
  return TaskStatus;
}({});
export const isValidTask = properties => {
  const ans = isValidBase(properties) && validateProps(properties, ['description', 'source', 'status']);
  return ans;
};
export const isValidEnrichedTask = properties => {
  const ans = isValidTask(properties) && validateProps(properties, ['actions', 'services', 'contacts', 'calendars']);
  return ans;
};
//# sourceMappingURL=Task.js.map